import { ApiRequest, RequestMethod } from "../../request";

export async function removeSkill(
  fighterId: string,
  skillId: string,
): Promise<boolean> {
  const apiRequest = new ApiRequest();
  apiRequest.setMethod(RequestMethod.DELETE);
  apiRequest.setUrl(`/api/fighter/${fighterId}/skill/${skillId}`);
  return (await apiRequest.send()).status === 200;
}
